export default class MapElementStyle {
    constructor(id, url) {
        this.id = id;
        this.url = url;
    }
}